import {CircularProgress, Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import BasicCard from "../../components/card";
import {getNegativeSentiment, getNegative_sentiment_curated, getPositiveSentiment, getPositive_sentiment_curated} from "../../Services/apiRoutes";
import BasicModal from "../../components/Modal";
import {getCryptoLogoMap} from "../../utils/utility";

const filterout = ["XDATA"];
let coinSymbol = [];
const ReviewCards = () => {
  const [positiveSentiments, setPositiveSentiments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [neg, setNegative] = useState([]);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const [cardDetails, setCardDetails] = useState({});
  const [iconURL, setIconURL] = useState({});

  const handleClose = () => {
    setOpen(false);
    setCardDetails(false);
  };

  const onReadMore = (cardDetails) => {
    setCardDetails(cardDetails);
    setOpen(true);
  };

  function handleHashChange() {
    // Get the new hash value from the URL
    const newHash = window.location.hash;

    // Update your React app with the new data based on the hash value
    // For example:
    if (newHash === "#curated") {
      // Update your app with data for curated insights
      // appRoot.setState({ insights: curatedInsightsData });
      fetchDataforCuratedCard("curated");
    } else if (newHash === "#ai") {
      // Update your app with data for all insights
      // appRoot.setState({ insights: allInsightsData });
      fetchDataforAiCard("all");
    } else {
      fetchDataforAllCard();
    }
  }

  useEffect(() => {
    // const eventID = (window.onhashchange = handleHashChange);
    handleHashChange();
    return () => {
      // window.removeEventListener(eventID,);
    };
  }, []);

  const pushCoins = (dataArray) => {
    dataArray.forEach((data) => {
      if (data.coins.length)
        data?.coins?.forEach((coin) => {
          coinSymbol.push(coin);
        });
    });
  };

  const fetchDataforAiCard = async () => {
    try {
      let positiveSentimentsData = await getPositiveSentiment();
      let negative = await getNegativeSentiment();
      const splicedPositiveArray = positiveSentimentsData.slice(0, 10);
      const splicedNegativeArray = negative.slice(0, 10);
      console.log("sentiment.title:", positiveSentimentsData);
      // splicedPositiveArray.forEach((data) => {
      //   if (data.coins.length)
      //     data?.coins?.forEach((coin) => {
      //       coinSymbol.push(coin);
      //     });
      // });
      // splicedNegativeArray.forEach((data) => {
      //   if (data.coins.length)
      //     data?.coins?.forEach((coin) => {
      //       coinSymbol.push(coin);
      //     });
      // });
      pushCoins(splicedPositiveArray);
      pushCoins(splicedNegativeArray);
      let result = await getResult();
      setIconURL(result);
      setPositiveSentiments(splicedPositiveArray);
      setNegative(splicedNegativeArray);
    } catch (error) {
      console.log(error);
    } finally {
      setType("curated");
      setLoading(false);
    }
  };

  const getResult = async () => {
    var result= await getCryptoLogoMap(coinSymbol);
    return result;
  };
  console.log("final data", iconURL);
  const fetchDataforAllCard = async () => {
    Promise.allSettled([getPositive_sentiment_curated(), getNegative_sentiment_curated(), getPositiveSentiment(), getNegativeSentiment()])
      .then(async (results) => {
        const fulfilledResults = results.filter((result) => result.status === "fulfilled").map((result) => result.value);

        const positiveCuratedData = fulfilledResults[0].slice(0, 10);
        const negativeCuratedData = fulfilledResults[1].slice(0, 10);
        const positiveData = fulfilledResults[2].slice(0, 10);
        const negativeData = fulfilledResults[3].slice(0, 10);
        pushCoins(positiveCuratedData);
        pushCoins(negativeCuratedData);
        pushCoins(positiveData);
        pushCoins(negativeData);
        let result = await getResult();
        setIconURL(result);
        setPositiveSentiments([...positiveCuratedData, ...positiveData]);
        setNegative([...negativeCuratedData, ...negativeData]);
      })
      .catch((error) => {
        console.log("Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchDataforCuratedCard = async () => {
    try {
      let positiveSentimentsData = await getPositive_sentiment_curated();
      let negativeSentimentsData = await getNegative_sentiment_curated();
      const splicedPositiveArray = positiveSentimentsData.slice(0, 10);
      const splicedNegativeArray = negativeSentimentsData.slice(0, 10);
      // console.log("curated postive", positiveSentimentsData);
      // console.log("curated negative", negativeSentimentsData);
      pushCoins(splicedPositiveArray);
      pushCoins(splicedNegativeArray);
      let result = await getResult();
      setIconURL(result);
      setPositiveSentiments(splicedPositiveArray);
      setNegative(splicedNegativeArray);
    } catch (error) {
      console.log("error in curated", error);
    } finally {
      setType("curated");
      setLoading(false);
    }
  };
  return (
    <div>
      {/* {inter} */}
      {open && <BasicModal open={open} handleClose={handleClose} cardDetails={cardDetails} />}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "50px",
            marginLeft:"auto",
            marginRight:"auto",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Grid
          container
          gap={5}
          columns={{sm: 10, md: 5}}
          sx={{
            justifyContent: "center",
            marginTop: "20px",
          }}
          className="grid-container"
        >
          <Grid container sm={1} md={4} alignContent="flex-start" gap={5}>
            {positiveSentiments.map((sentiment) => (
              <Grid
                key={sentiment?._id}
                item
                sx={{
                  backgroundColor:"blue",
                  minWidth: "100%",
                }}
              >
                <BasicCard positive category={sentiment.Category} icons={iconURL} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.weighted_average} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} onReadMore={onReadMore} source={sentiment.source} datetime={sentiment.datetime} />
              </Grid>
            ))}
          </Grid>
          <Grid container sm={1} md={4} alignContent="flex-start" gap={5}>
            {neg.map((sentiment) => (
              <Grid
                key={sentiment._id}
                item
                sx={{
                  minWidth: "100%",
                }}
              >
                <BasicCard positive={false} category={sentiment.Category} icons={iconURL} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.weighted_average} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} onReadMore={onReadMore} datetime={sentiment.datetime} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default React.memo(ReviewCards);
